import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Card, Tooltip, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import SideMenu from "./SideMenu.js";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

// Custom tooltip styling
const StyledTooltip = styled(props => (
  <Tooltip
    arrow
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: { offset: "0px, -45px, 20px, -25px" },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: rgba(97, 97, 97, 0.9);
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }
`;

const CardContainerDiv = styled("div")({
  marginLeft: "3rem",
  textAlign: "center",
  padding: 2,
  paddingRight: 10,
});

const ContainerDiv = styled("div")({
  marginBottom: "5rem",
  clear: "both",
  borderRadius: "8px",
});

const StyledIconButton = styled(IconButton)({
  backgroundColor: "#fff",
  color: "#EF5658 !important",
  border: "1px solid lightGray",
  position: "absolute",
  width: 30,
  height: 30,
  "&:hover": {
    backgroundColor: "#EF5658",
    border: "1px solid lightGray",
    color: "#fff !important",
  },
});

function AdminSideMenu({ selectedMenu, selectedSubMenu }) {
  const [adminMenu, setَAdminMenu] = useState([]);
  const location = useLocation();

  const temp = [
    {
      subheader: "Dashboard",
      icon: "Home",
      href: "/t31u4YYky50K/dashboard",
      items: [],
    },
    {
      subheader: "Moderation",
      icon: "Report",
      items: [
        {
          title: "Report List",
          href: "/t31u4YYky50K/moderation-list",
        },
      ],
    },
    {
      subheader: "Users",
      icon: "Users",
      items: [
        {
          title: "Waitlist",
          href: "/t31u4YYky50K/waitlist",
        },
        {
          title: "Users List",
          href: "/t31u4YYky50K/users-list",
        },
      ],
    },
    {
      subheader: "Toys Management",
      icon: "Users",
      items: [
        {
          title: "Toys List",
          href: "/t31u4YYky50K/toys-list",
        },
      ],
    },
    {
      subheader: "Stories Management",
      icon: "Users",
      items: [
        {
          title: "Stories List",
          href: "/t31u4YYky50K/stories-list",
        },
      ],
    },
    {
      subheader: "Videos Management",
      icon: "Video",
      items: [
        {
          title: "Videos List",
          href: "/t31u4YYky50K/videos-list",
        },
      ],
    },
  ];

  useEffect(() => {
    setَAdminMenu(temp);
  }, []);

  const [menuStatus, setMenuStatus] = useState({
    simple: selectedMenu ? selectedMenu : "Dashboard",
    expand: null,
  });

  const [subMenu, setSubMenu] = useState({
    menu: selectedMenu,
    sub: selectedSubMenu,
  });

  useEffect(() => {
    if (location.pathname.indexOf("/waitlist") !== -1) {
      setMenuStatus({
        simple: "Users",
        expand: null,
      });
      setSubMenu({
        menu: "Users",
        sub: "Waitlist",
      });
    }
    if (location.pathname.indexOf("/moderation-list") !== -1) {
      setMenuStatus({
        simple: "Moderation",
        expand: null,
      });
      setSubMenu({
        menu: "Moderation",
        sub: "Report List",
      });
    }
    if (location.pathname.indexOf("/toys-list") !== -1) {
      setMenuStatus({
        simple: "Toys Management",
        expand: null,
      });
      setSubMenu({
        menu: "Toys Management",
        sub: "Toys List",
      });
    }
    if (location.pathname.indexOf("stories/-list") !== -1) {
      setMenuStatus({
        simple: "Stories Management",
        expand: null,
      });
      setSubMenu({
        menu: "Stories Management",
        sub: "Stories List",
      });
    }
    if (location.pathname.indexOf("videos/-list") !== -1) {
      setMenuStatus({
        simple: "Videos Management",
        expand: null,
      });
      setSubMenu({
        menu: "Videos Management",
        sub: "Videos List",
      });
    }
  }, [location]);

  return (
    <CardContainerDiv>
      <ContainerDiv>
        <Card
          style={{
            width: menuStatus.simple ? 100 : 280,
            minHeight: 870,
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <Box pt={0} style={{ width: menuStatus.expand ? "93%" : "80%" }}>
              {adminMenu.map(menu => (
                <SideMenu
                  subheader={menu.subheader}
                  items={menu.items}
                  href={menu.href}
                  icon={menu.icon}
                  menuStatus={menuStatus}
                  subMenu={subMenu}
                  menuStatusFunc={item => setMenuStatus(item)}
                  subMenuFunc={item => setSubMenu(item)}
                />
              ))}
            </Box>
            <Box pt={3}>
              <StyledIconButton>
                {menuStatus.simple && (
                  <StyledTooltip title="Expand menu" placement="top">
                    <KeyboardArrowRightIcon
                      onClick={() => {
                        setMenuStatus({
                          simple: null,
                          expand: menuStatus.simple,
                        });
                      }}
                    />
                  </StyledTooltip>
                )}
                {menuStatus.expand && (
                  <StyledTooltip title="Collapse menu" placement="top">
                    <KeyboardArrowLeftIcon
                      onClick={() => {
                        if (subMenu.menu === menuStatus.expand)
                          setMenuStatus({ simple: menuStatus.expand, expand: null });
                        else setMenuStatus({ simple: subMenu.menu, expand: null });
                      }}
                    />
                  </StyledTooltip>
                )}
              </StyledIconButton>
            </Box>
          </Box>
        </Card>
      </ContainerDiv>
    </CardContainerDiv>
  );
}

export default AdminSideMenu;
